// Mesma regra do backend (utils/faturaUtils.ts): fatura em aberto cuja leitura de
// energia ainda nao foi lancada -> valor incompleto, pagamento bloqueado para o cliente.
export function aguardandoLeitura(fatura) {
    if (!fatura) return false;
    const emAberto = fatura.status === 'PENDENTE' || fatura.status === 'ATRASADO';
    const calcao = typeof fatura.observacao === 'string' && fatura.observacao.startsWith('Calção');
    return emAberto && !fatura.leituraLancada && !calcao;
}
